import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiGet, apiPost, apiRemove } from 'api-service';
import { xor } from 'lib';
import { bulletinSettingsInitialState } from './bulletinSettingsInitialState';

export const fetchBulletinSettings = createAsyncThunk(
  'bulletinSettingsReducer/fetchBulletinSettings',
  async (payload, thunkAPI) => {
    const { sortedPlatforms } = thunkAPI.getState().bulletinSettingsReducer;
    try {
      const response = await apiGet('/user/user-settings', {
        key: 'bulletin_settings',
      });

      const newSortedPlatforms = xor(
        response.data.result.data?.value?.sortedPlatforms || [],
        sortedPlatforms
      );

      return {
        headerConfig:
          response.data.result.data?.value?.headerConfig ??
          bulletinSettingsInitialState?.headerConfig,
        firstPageConfigs:
          response.data.result.data?.value?.firstPageConfigs ??
          bulletinSettingsInitialState?.firstPageConfigs,
        generalConfigs: {
          ...bulletinSettingsInitialState?.generalConfigs,
          ...response.data.result.data?.value?.generalConfigs,
        },
        highlightWords:
          response.data.result.data?.value?.highlightWords ??
          bulletinSettingsInitialState?.highlightWords,
        sortedPlatforms: [
          ...(response.data.result.data?.value?.sortedPlatforms ?? []),
          ...newSortedPlatforms,
        ],
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateBulletinSettings = createAsyncThunk(
  'bulletinSettingsReducer/updateBulletinSettings',
  async (payload, thunkAPI) => {
    const bulletinSettingsState = thunkAPI.getState().bulletinSettingsReducer;

    const value = {
      headerConfig: {
        ...bulletinSettingsState.headerConfig,
        ...payload?.headerConfig,
      },
      firstPageConfigs: {
        ...bulletinSettingsState.firstPageConfigs,
        ...payload?.firstPageConfigs,
      },
      generalConfigs: bulletinSettingsState.generalConfigs,
      highlightWords: bulletinSettingsState.highlightWords,
      sortedPlatforms: bulletinSettingsState.sortedPlatforms,
    };

    try {
      const response = await apiPost('/user/user-settings', {
        key: 'bulletin_settings',
        value: value,
      });
      return response.data.result.data.value;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const uploadGeneralImage = createAsyncThunk(
  'bulletinSettingsReducer/uploadGeneralImage',
  async (params, thunkAPI) => {
    try {
      const response = await apiPost('/user/setting/file', params?.formData);

      return response.data.result.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const removeGeneralImage = createAsyncThunk(
  'bulletinSettingsReducer/removeGeneralImage',
  async (params, thunkAPI) => {
    try {
      const response = await apiRemove(
        `/user/setting/file/${params?.filename}`
      );

      return response?.data?.result;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
